module.exports = __webpack_public_path__ + "img/image36.915fa668.png";